module.exports = __webpack_public_path__ + "img/Producthunt-bro.a20fbd71.png";